import {
  getLocationsBody,
  getLocationsHeader,
  getLocationsMasthead,
  getLocationsRoot,
} from 'redux/modules/content/selectors';
import { branchList } from 'redux/fetchers/branch-list';
import { fetchForgottenFavourites } from 'redux/modules/favourites/actions/fetch-forgotten-favourites';
import { getGridAemItems } from 'redux/modules/search-and-browse/selectors';
import getPendingOrders from 'redux/modules/orders/actions/get-pending-orders';

import getChildComponents from 'content/utils/convert-component-tree-to-array';

import {
  AMEND_ORDER_WIDGET,
  FORGOTTEN_FAVOURITES,
  FORM,
} from '@johnlewispartnership/wtr-content-component-library/dist/component-library/constants/cmsResourceTypes';

import {
  BRANCH_FEEDBACK_AEM_TYPE,
  PRODUCT_ISSUES_AEM_TYPE,
  STOCK_QUERIES_AEM_TYPE,
} from 'constants/customerServiceForms';
import { isPendingOrdersLoaded } from 'redux/modules/orders/selectors/get-orders';
import { EOS_NEW_INTERSTITIALS } from 'constants/monetateExperiments';
import { getAllDecisions } from 'redux/modules/experiments/selectors';

export const componentDataFetcher = () => (dispatch, getState) => {
  const dispatchAndSwallow = action => dispatch(action).catch(() => {});

  const state = getState();
  const components = [
    ...getLocationsBody(state),
    ...getLocationsHeader(state),
    ...getLocationsMasthead(state),
    ...getLocationsRoot(state),
    ...getGridAemItems(state),
  ];

  const newInterstitials =
    getAllDecisions(state).EoS_newInterstitials === EOS_NEW_INTERSTITIALS.variant.newCall;

  // Add fetches here to ensure data is loaded on demand for AEM components
  const promises = getChildComponents(components).map((component = {}) => {
    const orderOptions = { iHandleStatusCodes: true };
    const { formType, resourceType } = component;

    switch (resourceType) {
      case AMEND_ORDER_WIDGET: {
        const pendingOrdersLoaded = isPendingOrdersLoaded(state);
        return pendingOrdersLoaded ? null : dispatchAndSwallow(getPendingOrders(orderOptions));
      }
      case FORGOTTEN_FAVOURITES:
        return newInterstitials ? null : dispatch(fetchForgottenFavourites());
      case FORM:
        if (
          formType === BRANCH_FEEDBACK_AEM_TYPE ||
          formType === PRODUCT_ISSUES_AEM_TYPE ||
          formType === STOCK_QUERIES_AEM_TYPE
        ) {
          return dispatch(branchList());
        }
        return null;
      default:
        return null;
    }
  });

  return Promise.all(promises);
};
